<template>
    <div class="home-news-section" v-if="pageSetup != null">
        <div class="container">
            <div class="news-title">
                <h3>{{ pageSetup.news_section_title }}</h3>
            </div>
            <div class="news-tricker" v-if="newsItems != null">
                <swiper :options="swiperOption" ref="promoCarousel">
                    <swiper-slide v-for="(slide, index) in newsItems" :key="index">
                        <router-link :to="{ name: 'news-card' , params:{'id' : slide.slug}}" @click.native="startLoader">
                            <span>{{ slide.title }}</span>
                        </router-link>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'home-news-section',
        components: {
        },
        data () {
            return {
                swiperOption: {
                    spaceBetween: 20,
                    speed: 6000,
                    // slidesPerView: 'auto',
                    slidesPerView: 1,
                    allowTouchMove: false,
                    loop: true,
                    autoplay: {
                        delay: 1,
                        // disableOnInteraction: true,
                    },
                }
            }
        },
        computed: mapGetters({
            pageSetup: 'loadIndexPage',
            newsItems: 'loadNewsItems',
        }),
        methods: {
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-news.scss';
    @import '@/styles/components/home-page/respond/home-news-respond.scss';
</style>